import React from 'react';

import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {gt} from 'app/utils/i18n';

import {LoadingList} from './LoadingList';
import {useDocumentLoader} from './user-document-loader';

import type {AssignedDocType} from './types';
import type {TaskAssignableContentTypes} from 'sweet-types';

interface Props {
  contentType: TaskAssignableContentTypes;
  objectId: number;
  onDocumentFetch: (result: AssignedDocType) => unknown;
}

export function FetchDocumentForm({
  contentType,
  objectId,
  onDocumentFetch,
}: Props): JSX.Element {
  const {
    currentData: document,
    error,
    refetch,
  } = useDocumentLoader({contentType, objectId});

  React.useEffect(() => {
    if (document != null) {
      onDocumentFetch(document);
    }
  }, [document]);

  return error != null ? (
    <NoResultsMessage
      icon="fa-exclamation-triangle text-warning"
      head={gt('Could not load the assigned document')}
      onSidebar={true}
    >
      <button className="btn btn-primary" onClick={refetch}>
        {gt('Try again')}
      </button>
    </NoResultsMessage>
  ) : (
    <LoadingList />
  );
}
